import { IPage } from '@websolutespa/bom-core';
import React from 'react';
import { createGenericContext } from '../useGenericContext/useGenericContext';

export type IPageContext = IPage;

const [usePage, PageContextProvider] = createGenericContext<IPageContext>();

function PageProvider({ children, page }: { children?: React.ReactNode, page: IPage }) {
  return (
    <PageContextProvider value={page}>
      {children}
    </PageContextProvider>
  );
}

export { PageProvider, usePage };

